export const ENUM_CATEGORIES_CONTACT_REQUESTS = [
  {
    id: 1,
    value: 'headhunting_services',
    name_en: 'Headhunting services',
    name_vi: 'Dịch vụ tìm kiếm nhân sự'
  },
  {
    id: 2,
    value: 'job_posting_services',
    name_en: 'Job Posting services',
    name_vi: 'Dịch vụ đăng tuyển việc làm'
  },
  {
    id: 3,
    value: 'support_job_posting',
    name_en: 'Support Job Posting',
    name_vi: 'Hỗ trợ đăng tuyển việc làm'
  },
  {
    id: 4,
    value: 'employer_branding',
    name_en: 'Employer Branding',
    name_vi: 'Thương hiệu tuyển dụng'
  },
  {
    id: 5,
    value: 'bug_reporting',
    name_en: 'Bug reporting',
    name_vi: 'Thông báo lỗi'
  },
  {
    id: 6,
    value: 'other',
    name_en: 'Other',
    name_vi: 'Khác'
  }
]
